import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ActivityIndicator } from 'react-native';
import Navbar from 'react-bootstrap/Navbar';
import BaseNav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import { useThemeMode } from '@rneui/themed';
import { NavbarBrand } from '@annunciate/web/dist/components/NavbarBrand';
import { useChannelSettingsQuery } from '@annunciate/query';
import { useAuthStateStore } from '@annunciate/core';
import { AdminBanner, useReactiveThemeProperty } from '@annunciate/ui';
import { NavItem } from './navigation';
import { DEFAULT_NAV } from '../utils/navigation';
import { useOnNavigate } from '../hooks';
export const Nav = () => {
    const ref = useRef(null);
    const [pathname, setPathname] = useState('');
    const { mode } = useThemeMode();
    const onNavigate = useOnNavigate();
    const horizontalGutter = useReactiveThemeProperty('horizontalGutter');
    useEffect(() => {
        setPathname(window.location.pathname);
    }, []);
    useEffect(() => {
        const navHeight = ref.current?.clientHeight;
        if (navHeight !== undefined) {
            const navBarStyleId = 'nav-bar-height';
            let style = document.querySelector(`style[id="${navBarStyleId}"]`);
            if (!style) {
                style = document.createElement('style');
                style.id = navBarStyleId;
            }
            style.innerHTML = `:root { --nav-bar-height: ${navHeight}px; }`;
            document.head.appendChild(style);
        }
    }, [ref.current?.clientHeight]);
    const [hasAuthInitialized, isAuthenticated] = useAuthStateStore((state) => [
        state.hasAuthInitialized,
        state.uuid !== undefined,
    ]);
    const filter = useCallback(({ authenticationStates }) => {
        return (isAuthenticated && authenticationStates?.authenticated) ||
            (!isAuthenticated && authenticationStates?.unauthenticated);
    }, [
        isAuthenticated,
    ]);
    const { isPending, data } = useChannelSettingsQuery();
    const nav = data && data?.channel?.settings?.nav;
    const primary = (nav?.primary && nav.primary.length > 0 ? nav.primary : DEFAULT_NAV.primary);
    const secondary = (nav?.secondary && nav.secondary.length > 0 ? nav.secondary : DEFAULT_NAV.secondary);
    return (React.createElement("div", { ref: ref },
        React.createElement(Navbar, { sticky: "top", expand: "md", variant: mode, bg: mode, style: {
                paddingLeft: horizontalGutter,
                paddingRight: horizontalGutter,
            } },
            React.createElement(Container, { fluid: true, style: { paddingLeft: 0, paddingRight: 0 } },
                React.createElement(NavbarBrand, null),
                React.createElement(Navbar.Toggle, { "aria-controls": "main-navbar-nav" }),
                React.createElement(Navbar.Collapse, { id: "main-navbar-nav" }, !isPending && (React.createElement(React.Fragment, null,
                    React.createElement(BaseNav, { className: "me-auto", activeKey: pathname, onSelect: (selectedKey) => {
                            if (selectedKey) {
                                setPathname(selectedKey);
                            }
                        } }, primary
                        .filter(filter)
                        .map((node, i) => (React.createElement(NavItem, { node: node, key: i, onNavigate: onNavigate })))),
                    React.createElement(BaseNav, { activeKey: pathname },
                        hasAuthInitialized && secondary
                            .filter(filter)
                            .map((node, i) => (React.createElement(NavItem, { node: node, key: i, onNavigate: onNavigate }))),
                        !hasAuthInitialized && React.createElement(ActivityIndicator, null))))))),
        React.createElement(AdminBanner, null)));
};
//# sourceMappingURL=Nav.js.map